export const WEBINAR_TITLE_MAX_LENGTH = 100;

export function buildEvergreenPrefillTitle(baseTitle: string): string {
  const base = baseTitle.trimEnd();
  if (base.length <= WEBINAR_TITLE_MAX_LENGTH) {
    return base;
  }
  return base.slice(0, WEBINAR_TITLE_MAX_LENGTH).trimEnd();
}
